import { URLS, getAPIEndPoint } from "../consts/APIEndpoints";
import { REPORT_INTERVALS } from "../consts/Campaign";
import { getResponse } from "../utils/common";
import { determineBucketSize } from "../utils/reports";

export async function updateTeam(teamId, team) {
  return await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}/${teamId}`,
    "put",
    team
  );
}

export async function postTeam(teamConfig) {
  return await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}`,
    "post",
    teamConfig
  );
}

export async function getTeamStats(teamId, params) {
  return await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}/${teamId}/stats`,
    "get",
    undefined,
    params
  );
}

export async function getTeamStatsBySSOTFilter(teamId, params) {
  return await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}/${teamId}/stats/query`,
    "post",
    params
  );
}

export async function getTeamEvents(teamId, startDate, endDate, selectedCampaignTypes = []) {
  let aggregateBy = REPORT_INTERVALS.DAYS;
  if (startDate && endDate)
    aggregateBy = await determineBucketSize(startDate, endDate);

  const response = await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}/${teamId}/events`,
    "get",
    undefined,
    {
      type: "view,click,sent",
      start_date: startDate,
      end_date: endDate,
      aggregate_by: aggregateBy,
      CampaignType: selectedCampaignTypes.length >= 3 ? "" : selectedCampaignTypes.join(",")
    }
  );
  response.aggregateBy = aggregateBy;
  return response;
}

export async function getTeamEventsBySSOTFilter(teamId, startDate, endDate, selectedCampaignTypes = [], filters = null) {
  let aggregateBy = REPORT_INTERVALS.DAYS;
  if (startDate && endDate)
    aggregateBy = await determineBucketSize(startDate, endDate);

  // CampaignType is always "advanced" — POST /events/query is exclusively for personalized
  // campaigns with SSOT filters active; the filter panel is gated behind "advanced" only mode
  const params = {
    type: "view,click,sent",
    start_date: startDate,
    end_date: endDate,
    aggregate_by: aggregateBy,
    CampaignType: "advanced",
  };

  if (filters) {
    params.filters = filters;
  }

  const response = await getResponse(
    `${getAPIEndPoint(URLS.TEAMS_API)}/${teamId}/events/query`,
    "post",
    params
  );
  response.aggregateBy = aggregateBy;
  return response;
}
